import React from 'react';
import { Button, Card, Col, Input, Popconfirm, Row, Table } from 'antd';
import {
  QuestionCircleOutlined,
  DeleteOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import PropTypes from 'prop-types';
import EditableFormRow from './EditableFormRow';
import EditableCell from './EditableCell';
import { NEW_ITEM_VALUE } from './Constant';
import ColorPicker from '../ColorPicker/ColorPicker';
import Authorized from '../Authorization/Authorized';

const { Search } = Input;

class EditableTableWithColors extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRowKeys: [],
      filterValue: '',
    };
  }

  async componentDidMount() {
    const { retrieveAll } = this.props;
    await retrieveAll();
  }

  handleDelete = id => {
    const { delete: delete1 } = this.props;
    delete1(id);
    this.handleClearSelection();
  };

  handleMultipleDelete = () => {
    const { delete: delete1 } = this.props;
    const { selectedRowKeys } = this.state;
    delete1(selectedRowKeys.join(','));
    this.handleClearSelection();
  };

  handleClearSelection = () => {
    const { parentSelection } = this.props;
    this.setState({
      selectedRowKeys: [],
    });
    if (parentSelection) {
      parentSelection(0);
    }
  };

  handleAdd = () => {
    const { dataSource, save } = this.props;
    
    const newData = {
      value: NEW_ITEM_VALUE,
      color: '#9B9B9B',
    };
    save(newData);
  };

  handleSave = row => {
    
    const { save } = this.props;
    this.setState({
      filterValue: '',
    });
    save(row, row.id);
  };

  onSelectChange = selectedRowKeys => {
    
    this.setState({ selectedRowKeys });
    const { parentSelection } = this.props;
    if (parentSelection) {
      parentSelection(selectedRowKeys[selectedRowKeys.length - 1]);
    }
  };

  handleSearch = value => {
    const { retrieveAll } = this.props;
    this.setState({
      filterValue: value,
    });
    retrieveAll(value);
  };

  render() {
    const { parentType } = this.props;
    const { dataSource } = this.props;
    const components = {
      body: {
        row: EditableFormRow,
        cell: EditableCell,
      },
    };
    const { save } = this.props;
    const columnDefinition = [
      {
        title: 'value',
        dataIndex: 'value',
        editable: true,
      },
      {
        title: 'color',
        dataIndex: 'color',
        render: (text, record) => (
          <ColorPicker record={record.color} saveRecord={save} />
        ),
      },
      {
        title: 'action',
        dataIndex: 'action',
        width: '20%',
        render: (text, record) => (
          // eslint-disable-next-line react/destructuring-assignment
          // TODO: what if number of elements in data source is less than 1 ? possible bug
          // this.props.dataSource.length >= 1 ? (<Popconfirm>) : null
          <Authorized asset={parentType} operation="write">
            <Popconfirm
              title="Sure to delete?"
              icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
              onConfirm={() => this.handleDelete(record.id)}
            >
              <Button icon={<DeleteOutlined />} />
            </Popconfirm>
          </Authorized>
        ),
      },
    ];

    const columns = columnDefinition.map(col => {
      if (!col.editable) {
        return {
          ...col,
          onCell: record => ({
            record,
            align: 'center',
          }),
        };
      }
      return {
        ...col,
        onCell: record => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: this.handleSave,
          parentType,
        }),
      };
    });
    // rowSelection object indicates the need for row selection
    const { selectedRowKeys } = this.state;
    const hasSelected = selectedRowKeys.length > 0;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };

    const { cardTitle, loading } = this.props;
    const { filterValue } = this.state;
    return (
      <div>
        <Card
          title={cardTitle}
          bordered={false}
          loading={loading}
          extra={
            <div>
              <Authorized asset={parentType} operation="write">
                <Button
                  icon={<DeleteOutlined />}
                  onClick={this.handleMultipleDelete}
                  disabled={!hasSelected}
                  style={{ marginRight: 12 }}
                >
                  {/* Delete */}
                </Button>
                <Button
                  onClick={this.handleAdd}
                  type="primary"
                  icon={<PlusOutlined />}
                  // style={{ marginBottom: 16 }}
                >
                  {/* Add New */}
                </Button>
              </Authorized>
            </div>
          }
        >
          <Row style={{ paddingBottom: '8px' }}>
            <Search
              placeholder="Search"
              onSearch={value => this.handleSearch(value)}
              defaultValue={filterValue}
              allowClear
            />
          </Row>
          <Row justify="center" align="middle">
            <Col>
              <Table
                components={components}
                rowClassName={() => 'editable-row'}
                bordered={false}
                dataSource={dataSource}
                columns={columns}
                pagination={false}
                rowKey={record => record.id}
                size="small"
                rowSelection={rowSelection}
                showHeader={false}
                // scroll={{ y: 550 }}
              />
            </Col>
          </Row>
          <Authorized asset={parentType} operation="write">
            <Row type="flex" justify="center" style={{ paddingTop: '15px' }}>
              <Button
                onClick={this.handleAdd}
                type="primary"
                icon={<PlusOutlined />}
                // style={{ marginBottom: 16 }}
              >
                Add
              </Button>
            </Row>
          </Authorized>
        </Card>
      </div>
    );
  }
}

EditableTableWithColors.propTypes = {
  dataSource: PropTypes.array,
  retrieveAll: PropTypes.func,
  save: PropTypes.func,
  delete: PropTypes.func,
  cardTitle: PropTypes.string,
  loading: PropTypes.bool,
  parentSelection: PropTypes.func,
  parentType: PropTypes.string,
};

export default EditableTableWithColors;
